module.exports = __webpack_public_path__ + "img/weenablebrands.31935aba.png";